import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "table-header p-d-flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "p-field-checkbox p-mt-4" }
const _hoisted_6 = { for: "findEmptyFields" }
const _hoisted_7 = {
  key: 0,
  class: "pi pi-flag"
}
const _hoisted_8 = { class: "p-d-flex p-jc-center p-ai-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_TabView, {
      onTabClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchTabConfirm($event.index))),
      activeIndex: _ctx.activeTab,
      "onUpdate:activeIndex": _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = $event)),
      lazy: "",
      "data-test": "tab-view",
      class: "internationalization-management kn-tab kn-page-content"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
          return (_openBlock(), _createBlock(_component_TabPanel, { key: language }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(language.language) + " ", 1),
              (language.defaultLanguage)
                ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('managers.internationalizationManagement.defaultLanguage')), 1))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_DataTable, {
                    key: 0,
                    editMode: "cell",
                    value: _ctx.messages,
                    loading: _ctx.loading,
                    class: "p-datatable kn-table",
                    dataKey: "id",
                    responsiveLayout: "stack",
                    breakpoint: "960px",
                    filters: _ctx.filters,
                    "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
                    "data-test": "messages-table"
                  }, {
                    header: _withCtx(() => [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("span", {
                          class: "p-input-icon-left p-mr-3",
                          style: _ctx.intDescriptor.headerStyles.searchBoxStyle
                        }, [
                          _hoisted_4,
                          _createVNode(_component_InputText, {
                            class: "kn-material-input",
                            modelValue: _ctx.filters['global'].value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                            type: "text",
                            placeholder: _ctx.$t('common.search'),
                            "data-test": "filterInput"
                          }, null, 8, ["modelValue", "placeholder"])
                        ], 4),
                        _createVNode("div", _hoisted_5, [
                          _createVNode(_component_Checkbox, {
                            id: "findEmptyFields",
                            binary: true,
                            modelValue: _ctx.showOnlyEmptyFields,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOnlyEmptyFields = $event)),
                            onChange: _ctx.filterEmptyMessages,
                            "data-test": "checkbox"
                          }, null, 8, ["modelValue", "onChange"]),
                          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.internationalizationManagement.showBlankMessages')), 1)
                        ])
                      ])
                    ]),
                    empty: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                    ]),
                    filter: _withCtx(({ filterModel }) => [
                      _createVNode(_component_InputText, {
                        type: "text",
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                        class: "p-column-filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        headerStyle: _ctx.intDescriptor.headerStyles.dirtyHeaderStyle
                      }, {
                        body: _withCtx((slotProps) => [
                          (slotProps.data['dirty'])
                            ? (_openBlock(), _createBlock("i", _hoisted_7))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["headerStyle"]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                        return (_openBlock(), _createBlock(_component_Column, {
                          field: col.field,
                          header: _ctx.$t(col.header),
                          key: col.field,
                          sortable: true,
                          class: { disabledColumn: col.disabled, editableColumn: !col.disabled }
                        }, {
                          body: _withCtx((slotProps) => [
                            (!col.disabled)
                              ? (_openBlock(), _createBlock(_component_InputText, {
                                  key: 0,
                                  modelValue: slotProps.data[slotProps.column.props.field],
                                  "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                                  class: "kn-material-input p-inputtext-sm p-p-2",
                                  onInput: ($event: any) => (_ctx.atFieldChange(slotProps)),
                                  "data-test": 'input-field-' + slotProps.data['id']
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "data-test"]))
                              : (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  class: { disabledCell: col.disabled, 'kn-disabled-text': col.disabled, editableCell: !col.disabled }
                                }, _toDisplayString(slotProps.data[slotProps.column.props.field]), 3))
                          ]),
                          _: 2
                        }, 1032, ["field", "header", "class"]))
                      }), 128)),
                      _createVNode(_component_Column, {
                        headerStyle: _ctx.intDescriptor.headerStyles.buttonsHeaderStyle
                      }, {
                        header: _withCtx(() => [
                          (language.defaultLanguage)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                label: _ctx.$t('managers.internationalizationManagement.table.addLabel'),
                                class: "p-button kn-button--primary",
                                onClick: _ctx.addEmptyLabel
                              }, null, 8, ["label", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        body: _withCtx((slotProps) => [
                          _createVNode("div", _hoisted_8, [
                            _withDirectives(_createVNode(_component_Button, {
                              icon: "pi pi-save",
                              class: "p-button-link",
                              onClick: ($event: any) => (_ctx.saveLabel(language, slotProps.data))
                            }, null, 8, ["onClick"]), [
                              [
                                _directive_tooltip,
                                _ctx.$t('common.save'),
                                void 0,
                                { top: true }
                              ]
                            ]),
                            (language.defaultLanguage)
                              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  icon: "pi pi-trash",
                                  class: "p-button-link",
                                  onClick: ($event: any) => (_ctx.deleteLabelConfirm(language, slotProps, true))
                                }, null, 8, ["onClick"])), [
                                  [
                                    _directive_tooltip,
                                    _ctx.$t('common.delete'),
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _createCommentVNode("", true),
                            (!language.defaultLanguage)
                              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  icon: "pi pi-times",
                                  class: "p-button-link",
                                  onClick: ($event: any) => (_ctx.deleteLabelConfirm(language, slotProps, false))
                                }, null, 8, ["onClick"])), [
                                  [
                                    _directive_tooltip,
                                    _ctx.$t('common.cancel'),
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["headerStyle"])
                    ]),
                    _: 2
                  }, 1032, ["value", "loading", "filters"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeIndex"])
  ]))
}